module.exports = __webpack_public_path__ + "static/media/ibu-10.5b70ceb8.png";